import hmd_softlock_logo from 'url:/assets/hmd_softlock_logo.svg'
import React from 'react'
import { Link, useSearchParams } from 'react-router'
import { INPUT_FORM_COMMON_SIZE } from '../../genericComponents/OverlayWrapper'
import { AuthPageContainer } from '../../genericComponents/layout/AuthPageContainer'
import { FlexContainer } from '../../genericComponents/layout/FlexContainer'

export const PasswordResetedPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const emailAddress = searchParams.get('emailAddress')
  return (
    <AuthPageContainer>
      <FlexContainer
        align="items-center"
        justify="justify-center"
        className={'flex-col ' + INPUT_FORM_COMMON_SIZE}
      >
        <img src={hmd_softlock_logo} alt="" className="mb-6 w-[160px]" />

        <h2 className="text-primaryFontColor text-base font-semibold text-center">Email sent!</h2>

        <p className="text-center">
          An email has been sent to your address <b>{emailAddress}</b>. Follow the instruction in
          the email to reset your password.
        </p>

        <Link
          to={`/login`}
          className="text-linkColor cursor-pointer no-underline flex justify-center"
        >
          Return to Sign in
        </Link>
      </FlexContainer>
    </AuthPageContainer>
  )
}
